import Vue from 'vue'

export default {
  install: function (Vue, options) {
    Vue.mixin({
      mounted() {
        window.addEventListener('scroll', this.g_handleScroll)
      },
      destroyed() {
        window.removeEventListener('scroll', this.g_handleScroll)
      },
      methods: {
        g_handleScroll: function () {
          if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            if (this.$options.scrollBottom) {
              this.$options.scrollBottom.apply(this)
            }
          }
        }
      }
    })
  }
} 


// WEBPACK FOOTER //
// ./src/plugins/scrollBottom.js